import { createAction } from 'redux-actions';

export const resetROPicklistView = createAction('RESET_RO_PICKLIST_VIEW');
